import { useApi } from "../hooks/useApi";
import { api } from "../lib/api";
import { PostCard } from "../components/PostCard";

export function PostPage({ id }: { id: string }) {
  const post = useApi(() => api.post(id), [id]);
  if (post.error) return <div className="state">This post is missing or unavailable.</div>;
  return <section className="post-page">{post.data ? <PostCard post={post.data} /> : <div className="state">Loading post...</div>}</section>;
}
